import React from 'react';

export default function PaperAirplaneSvgIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="#000"
        d="M3.743 10.901V9.285h15.495v1.616H3.743zm-.805-.81L.042 1.07C-.175.395.482-.226 1.09.08l18.474 9.282c.584.293.58 1.175-.005 1.463L1.085 19.922c-.61.301-1.262-.323-1.041-.997l2.894-8.835zm-.872-7.732l2.4 7.474a.854.854 0 0 1-.002.525l-2.39 7.296 15.37-7.568L2.066 2.359z"
      />
    </svg>
  );
}
